import VueGtm from 'vue-gtm';
import router from '@/router';
import { App } from 'vue';
import { app } from '@/main';
import { BeePalletGTagManagerId } from '@/beepallet.consts';


function insertGtmScript(gtmId: string) {
  if (document.getElementById('gtm-script')) return; // No duplicar

  const script = document.createElement('script');
  script.id = 'gtm-script';
  script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');
  `;
  document.head.appendChild(script);
}

function insertGtmNoScript(gtmId: string) {
  if (document.getElementById('gtm-noscript')) return; // No duplicar

  const noscript = document.createElement('noscript');
  noscript.id = 'gtm-noscript';
  noscript.innerHTML = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>
  `;

  document.body.appendChild(noscript);
}

export function useGTM(app: App) {
  app.use(VueGtm, {
    id: BeePalletGTagManagerId,
    vueRouter: router,
    enabled: true,
    debug: false,
  });
}

export function initGTMFromComponent() {
  console.log('app',app);
  if (app) {
    useGTM(app);
    insertGtmScript(BeePalletGTagManagerId);
    insertGtmNoScript(BeePalletGTagManagerId);
  } else {
    console.warn('No se pudo obtener la instancia de Vue para montar GTM.');
  }
}

export function sendGTMPageViewEvent(params?: Record<string, any>) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'manual_event_PAGE_VIEW',
    ...params,
  });
}